import logoOnDark from "../assets/helmr-logo-on-dark.svg";
import logoOnLight from "../assets/helmr-logo-on-light.svg";
import markOrange from "../assets/helmr-mark-orange.svg";
import markBlack from "../assets/helmr-mark-black.svg";
import s from "./logo.module.css";

export interface HelmrMarkProps {
  /** Ground the logo sits on: 'dark' (default) uses the on-dark artwork, 'light' the on-light one. */
  tone?: "dark" | "light";
  /** The H mark alone. Brand rule: use it whenever the logo would be narrower than about 96 px. */
  compact?: boolean;
  /** Accessible name. */
  title?: string;
}

/** The Helmr logo from the brand kit (static outlined SVGs; never recolour or stretch). Export name kept for call sites. */
export function HelmrMark({ tone = "dark", compact = false, title = "Helmr" }: HelmrMarkProps) {
  const dark = tone === "dark";
  const src = compact ? (dark ? markOrange : markBlack) : dark ? logoOnDark : logoOnLight;
  return <img className={compact ? s.compact : s.logo} src={src} alt={title} draggable={false} />;
}
